import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Container } from '@mui/material';
import { ScaffoldStyles } from './ScaffoldStyles';

export interface ScaffoldProps {
    title: string;
    actions: React.ReactNode;
    fullWidth?: boolean;
    children: React.ReactNode;
}

interface DrawerScaffoldProps extends ScaffoldProps {
    drawerContent: React.ReactNode;
}

const DrawerScaffold: React.FC<DrawerScaffoldProps> = ({ title, actions, drawerContent, children, fullWidth = false }) => {
    const classes = ScaffoldStyles();
    const [open, setOpen] = React.useState(false);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    return (
        <div className={classes.root}>
            <CssBaseline />

            <AppBar color={'default'} position="fixed" className={classes.appBar}>
                <Toolbar>
                    <IconButton color="inherit" aria-label="open drawer" onClick={handleDrawerOpen} edge="start" className={classes.menuButton}>
                        <MenuIcon />
                    </IconButton>

                    <div className={classes.grow}>
                        <h3>{title}</h3>
                    </div>
                    {actions}
                </Toolbar>
            </AppBar>
            <Drawer
                className={classes.drawer}
                anchor="left"
                open={open}
                onClose={handleDrawerClose}
                classes={{
                    paper: classes.drawerPaper
                }}
            >
                <div className={classes.drawerHeader}>
                    <IconButton onClick={handleDrawerClose}>
                        <ChevronLeftIcon />
                    </IconButton>
                </div>
                {drawerContent}
            </Drawer>
            <main className={classes.content}>
                <div className={classes.drawerHeader} />
                <Container maxWidth={fullWidth ? 'xl' : 'lg'}>{children}</Container>
            </main>
        </div>
    );
};

export default DrawerScaffold;
